import {
  ChevronsUpDown,
  Trash2,
  Printer,
  CloudDownload,
  Loader,
  MailCheck,
  Check
} from "lucide-react";
import React, { useState } from "react";
import DeleteModal from "../Modal/DeleteModal";
import { account_name, calculateAgeFromDOB, can_visit, exchangeDate, location_name, notify, setSecureData } from "../../helpers";
import { sendWaitingRoomMails } from "../../services/patient";
import OtpConfirmationModal from "../Modal/OtpConfirmationModal";
import { setPendingQmData } from "../../Session";
import ClinicalNoteViewModal from "../Modal/ClinicalNoteViewModal";
import Badge from "../UI/Badge";
import Skeleton from "react-loading-skeleton";
const maleAvatar = './images/avatar.png';
const femaleAvatar = './images/female.png';
const otherAvatar = './images/other.png';

const styles = {
  display: "flex",
  alignItems: "center",
  gap: "5px",
  cursor: "pointer",
};

export default function ClinicalNotesDataTable(props) {
  const {
    tableData = [],
    handleCheckboxChange = () => {},
    handleSelectAll = () => {},
    handleDeleteRecord = () => {},
    reloadData = () => {},
    reloadDataFilter = {},
    account_id,
    location_id,
    dataLoading,
    setDataLoading = () => {},
    checkSelected = false,
    downloadBulkData = () => {},
    buttonLoader = false,
    checkedIds = [],
    setCheckedIds = () => {},
    globalCheckedIds,
    setGlobalCheckedIds,
    previousScrollPosition = 0,
    setPreviousScrollPosition = () => {},
    clinicalNoteBulkDelete = false,
    setClinicalNoteBulkDelete = () => {},
  } = props;

  const [patientData, setPatientData] = useState({});
  const [orderBy, setOrderBy] = useState();
  const [deleteRecord, setDeleteRecord] = useState({});
  const [activeDeleteModal, setActiveDeleteModal] = useState(false);
  const [sendMailButtonLoader, setSendMailButtonLoader] = useState(false);
  const [sendMailConfirmationModal, setSendMailConfirmationModal] = useState(false);
  const [previsitViewStatus, setPrevisitViewStatus] = useState(false);
  const [clinicalNoteCheckIds, setClinicalNoteCheckIds] = useState([]);
  const [clinicalNoteCompletedIds, setClinicalNoteCompletedIds] = useState([]);
  const [clinicalNotePendingIds, setClinicalNotePendingIds] = useState([]);

  const handleOrderChange = (name, type = "asc") => {
    name = name.toString();
    setOrderBy(name);
    if (reloadDataFilter.order_by && reloadDataFilter.order_by[0] == name) {
      if (reloadDataFilter.order_by[1] == "asc") {
        type = "desc";
      }
    }
    const orderFilter = { order_by: [name, type.toString()] };
    const filter_merge = { ...reloadDataFilter, ...orderFilter };
    reloadData(filter_merge);
    setDataLoading(true);
  };

  const handleSendEmail = async () => {
    const data = {
      account_id: account_id,
      location_id: location_id,
      selected_ids: Array.from(globalCheckedIds),
      type: "email",
      speciality_id: reloadDataFilter?.speciality_id,
      provider_id: reloadDataFilter?.provider_id
    };
    setSendMailButtonLoader(true);

    try {
      const response = await sendWaitingRoomMails(data);
      if(response){
        if(response?.detail) {
          notify("error", response?.detail, 2);
        } else {
          if( response?.data?.status === "success"){
            notify("success", response?.data?.message, 2);
            setSendMailConfirmationModal(false);
            window.scrollTo(0, previousScrollPosition, 2);
            setGlobalCheckedIds(new Set());
          } else {
            notify("error", response?.data?.message, 2);
          }
        }
      }
    } catch (error) {
      if (error?.response && error?.response?.data && error?.response?.data?.detail) {
        notify("error", error?.response?.data?.detail, 0.5);
      }
    } finally {
      setSendMailButtonLoader(false);
    }
  };

  const handleReportNavigation = async () => {
    const _ = {
      account_id: account_id,
      location_id: location_id,
      selected_ids: Array.from(globalCheckedIds),
      type: "print",
      speciality_id: reloadDataFilter?.speciality_id,
      provider_id: reloadDataFilter?.provider_id,
    };
    await setSecureData(
      "pending_qm_data",
      JSON.stringify(_)      
    );  
    setPendingQmData(_)

    window.open(`/summary-report`, '_blank', 'noopener,noreferrer');
  };

  const removeSelection = () => {
    setCheckedIds([]);
    setGlobalCheckedIds(new Set());
  };

  const handleDelete = (item) => {
    setDeleteRecord(item);
    setActiveDeleteModal(true);
    setPreviousScrollPosition(window.scrollY);
    window.scrollTo(0, 0);
  }

  const handleViewPreVisit = (item) => {
    setPrevisitViewStatus(true);
    setPreviousScrollPosition(window.scrollY);
    window.scrollTo(0, 0);
    setPatientData(item);
  };


  return (
    <>
      {checkSelected && (
        <>
          <hr />
          <div className="docpro_data_table_btns">
            {(can_visit('clinical_notes') && can_visit('clinical_notes_delete')) && (
              <button className="docpro_bordered_btn docpro_fw_600 docpro_red_color"
                onClick={() => {
                  setClinicalNoteBulkDelete(!clinicalNoteBulkDelete);
                  setPreviousScrollPosition(window.scrollY);
                  window.scrollTo(0, 0);
                }}
              >
                <Trash2 width={20} height={20} />
                Delete
              </button>
            )}

            {/* <button 
              className="docpro_bordered_btn docpro_fw_600 docpro_primary_color"
              onClick={downloadBulkData}
              disabled = {buttonLoader ? true : false}
            >
              <CloudDownload width={20} height={20} />
              Download Selected PDF
              {buttonLoader && (
                <span className="docpro_loading">
                  <Loader width={20} height={20} />
                </span>
              )}
            </button>

            {can_visit('clinical_notes') && (
              <button 
                type="button"
                className="docpro_bordered_btn docpro_fw_600 docpro_primary_color"
                onClick={() => {
                  setSendMailConfirmationModal(true);
                  setPreviousScrollPosition(window.scrollY);
                  window.scrollTo(0, 0);
                }}
              >
                <MailCheck width={20} height={20} />
                <span>Send Summary</span>
              </button>
            )}

            {can_visit('clinical_notes') && (
              <button 
                className="docpro_bordered_btn docpro_fw_600 docpro_primary_color"
                onClick={() => handleReportNavigation()}
              >
                <Printer width={20} height={20} />
                Print Summary
              </button>
            )} */}

            {checkedIds?.length > 0 && (
              <div className='docpro_filtered_badge' style={{ margin: 0 }}>
                <span><b>Selected Patients</b>: {checkedIds?.length}</span>
                <button
                  onClick={removeSelection}
                >
                  ✕
                </button>
              </div>
            )}
          </div>
        </>
      )}
      <div className="docpro_table_responsive" style={{ minHeight: "450px" }}>
        <table className="docpro_mb_0" style={{ height: '100%' }}>
          <thead>
            <tr>
              <th style={{ width: "45px" }}>
                <div className="docpro_checkbox" style={{ top: "3px" }}>
                  <input
                    type="checkbox"
                    checked={tableData.length > 0 && tableData.every((row) => globalCheckedIds?.has(row?.id))}
                    onChange={handleSelectAll}
                    disabled={tableData.length === 0}
                  />
                  <label></label>
                </div>
              </th>
              {can_visit("_role_enterprise") && (
                <>
                  <th> Practice Name </th>
                  <th> Location </th>
                </>
              )}
              <th
                onClick={() => {
                  handleOrderChange("dos");
                }}
                className={`${orderBy === "dos" ? "docpro_accent_color" : ""}`}
              >
                <div style={styles}>
                  DOS <ChevronsUpDown size={"12"} />
                </div>
              </th>
              <th
                onClick={() => {
                  handleOrderChange("last_name");
                }}
                className={`${orderBy === "last_name" ? "docpro_accent_color" : ""}`}
              >
                <div style={styles}>
                  Last Name <ChevronsUpDown size={"12"} />
                </div>
              </th>
              <th
                onClick={() => {
                  handleOrderChange("first_name");
                }}
                className={`${orderBy === "first_name" ? "docpro_accent_color" : ""}`}
              >
                <div style={styles}>
                  First Name <ChevronsUpDown size={"12"} />
                </div>
              </th>
              <th
                onClick={() => {
                  handleOrderChange("dob");
                }}
                className={`${orderBy === "dob" ? "docpro_accent_color" : ""}`}
              >
                <div style={styles}>
                  Date of Birth <ChevronsUpDown size={"12"} />
                </div>
              </th>
              <th
                onClick={() => {
                  handleOrderChange("dob");
                }}
                className={orderBy === "dob" ? "docpro_accent_color" : ""}
              >
                <div style={styles}>
                  Age <ChevronsUpDown size={"12"} />
                </div>
              </th>
              <th
                onClick={() => {
                  handleOrderChange("gender");
                }}
                className={`${orderBy === "gender" ? "docpro_accent_color" : ""}`}
              >
                <div style={styles}>
                  Gender <ChevronsUpDown size={"12"} />
                </div>
              </th>
              <th
                onClick={() => {
                  handleOrderChange("status");
                }}
                className={`${orderBy === "status" ? "docpro_accent_color" : ""}`}
              >
                <div style={styles}>
                  Status <ChevronsUpDown size={"12"} />
                </div>
              </th>
              <th className="text-right"><span className="pr-2">Action</span></th>
            </tr>
          </thead>
          <tbody>
            {!dataLoading ? (
              tableData.length > 0 ? (
                tableData?.map((item, index) => (
                  <tr key={index} className={`row_${item.id}`}>
                    <td style={{ width: "45px" }}>
                      <div className="docpro_checkbox" style={{ top: "3px" }}>
                        <input
                          type="checkbox"
                          checked={globalCheckedIds.has(item.id)}
                          onChange={() => handleCheckboxChange(item.id, item)}
                        />
                        <label></label>
                      </div>
                    </td>
                    {can_visit("_role_enterprise") && (
                      <>
                        <td onClick={() => handleViewPreVisit(item)}>
                          {account_name(item?.account_id)}
                        </td>
                        <td onClick={() => handleViewPreVisit(item)}>
                          {location_name(item?.location_id)}
                        </td>
                      </>
                    )}
                    <td className="pointer" onClick={() => handleViewPreVisit(item)}>
                      {exchangeDate(item?.dos)}
                      {clinicalNoteCompletedIds.includes(item.id) ? (
                        <span style={{ marginLeft: 4, backgroundColor: "#74b976", borderRadius: "50%" }}>
                          <Check width={16} height={16} style={{ padding: "0 2px 2px", color: "#ffffff", strokeWidth: "3px" }} />
                        </span>
                      ) : item?.status === "completed" ? (
                        <span style={{ marginLeft: 4, backgroundColor: "#74b976", borderRadius: "50%" }}>
                          <Check width={16} height={16} style={{ padding: "0 2px 2px", color: "#ffffff", strokeWidth: "3px" }} />
                        </span>
                      ) : (
                        <span style={{ width: 20, display: 'inline-flex' }}></span>
                      )}
                    </td>
                    <td className="pointer" onClick={() => handleViewPreVisit(item)}>
                      <div className="flex items-center table_img">
                        <img src={item.gender === "Male" ? maleAvatar : item.gender === "Female" ? femaleAvatar : otherAvatar} alt="User" />
                        {item?.last_name}
                      </div>
                    </td>
                    <td className="pointer" onClick={() => handleViewPreVisit(item)}>
                      {item?.first_name}
                    </td>
                    <td className="pointer" onClick={() => handleViewPreVisit(item)}>
                      {exchangeDate(item?.dob)}
                    </td>
                    <td className="pointer" onClick={() => handleViewPreVisit(item)}>
                      {calculateAgeFromDOB(item?.dob)}y
                    </td>
                    <td className="pointer" onClick={() => handleViewPreVisit(item)}>
                      {item?.gender}
                    </td>
                    <td className="pointer" onClick={() => handleViewPreVisit(item)}>
                      {clinicalNotePendingIds.includes(item.id) ? (
                        <Badge color="red">Pending</Badge>
                      ) : clinicalNoteCompletedIds.includes(item.id) ? (
                        <Badge color="green">Completed</Badge>
                      ) : item?.status === "pending" ? (
                        <Badge color="red">Pending</Badge>
                      ) : item?.status === "completed" ? (
                        <Badge color="green">Completed</Badge>
                      ) : (
                        ""
                      )}
                    </td>

                    <td className="docpro_text_center">
                      <div className="docpro_icon_btns items-center" style={{ justifyContent: 'end' }}>
                        {can_visit('clinical_notes') && can_visit('clinical_notes_delete') && (
                          <button type="button" className="docpro_icon_btn last_btn_tip" onClick={() => handleDelete(item)}>
                            <Trash2 width={18} height={18} />
                            <span className="docpro_tip">Delete</span>
                          </button>
                        )}
                      </div>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td className="no_data docpro_p_0" style={{ height: "450px" }} colSpan={`${can_visit("_role_enterprise") ? 11 : 9}`}>
                    No data available
                  </td>
                </tr>
              )
            ) : (
              Array.from({ length: 8 }).map((_, index) => (
                <tr key={index} style={{ height: '50px' }}>
                  <td style={{ width: "45px" }}> <Skeleton width="1.2rem" borderRadius="8px"></Skeleton> </td>
                  {can_visit("_role_enterprise") && (
                    <>
                      <td> <Skeleton width={`${3 + (index % 2)}rem`} borderRadius="8px"></Skeleton> </td>
                      <td> <Skeleton width={`${4 + (index % 1.2)}rem`} borderRadius="8px"></Skeleton> </td>
                    </>
                  )}
                  <td> <Skeleton width="5rem" borderRadius="8px"></Skeleton> </td>
                  <td> <Skeleton width={`${5 + (index % 2.5)}rem`} borderRadius="8px"></Skeleton> </td>
                  <td> <Skeleton width={`${4 + (index % 3)}rem`} borderRadius="8px"></Skeleton> </td>
                  <td> <Skeleton width="5rem" borderRadius="8px"></Skeleton> </td>
                  <td> <Skeleton width="3rem" borderRadius="8px"></Skeleton> </td>
                  <td> <Skeleton width={`${2 + (index % 1.5)}rem`} borderRadius="8px"></Skeleton> </td>
                  <td> <Skeleton width={`${4 + (index % 1.8)}rem`} borderRadius="8px"></Skeleton> </td>
                  <td className="text-right"> <span className="pr-2"><Skeleton width="3rem" borderRadius="8px"></Skeleton></span> </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>

      {activeDeleteModal && (
        <DeleteModal
          handleDelete={() => handleDeleteRecord(deleteRecord?.id)}
          name={deleteRecord?.last_name + ' ' + deleteRecord?.first_name}
          activeModal={activeDeleteModal}
          setActiveModal={setActiveDeleteModal}
          previousScrollPosition={previousScrollPosition}
          setPreviousScrollPosition={setPreviousScrollPosition}
        />
      )}

      {sendMailConfirmationModal && (
        <OtpConfirmationModal
          actionType={handleSendEmail}
          openModal={sendMailConfirmationModal}
          setOpenModal={setSendMailConfirmationModal}
          enableOtpConfirmationLoader={sendMailButtonLoader}
          sendFrom="waiting"
          previousScrollPosition={previousScrollPosition}
        />
      )}

      {previsitViewStatus && (
        <ClinicalNoteViewModal
          account_id={account_id}
          location_id={location_id}
          clinical_id={patientData?.id}
          active_modal={previsitViewStatus}
          set_active_modal={setPrevisitViewStatus}
          previousScrollPosition={previousScrollPosition}
          setClinicalNoteCheckIds={setClinicalNoteCheckIds}
          clinicalNoteCompletedIds={clinicalNoteCompletedIds}
          setClinicalNoteCompletedIds={setClinicalNoteCompletedIds}
          setClinicalNotePendingIds={setClinicalNotePendingIds}
        />
      )}
    </>
  );
}
